var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "kcp-pay",
    attrs: {
      "id": "kcp-pay"
    }
  }, [_vm.detect === 'pc' ? _c('form', {
    ref: "pcForm",
    attrs: {
      "name": "order_info",
      "action": "/api/plugins/kcp/pay/response",
      "method": "post",
      "enctype": "application/x-www-form-urlencoded"
    }
  }, [_c('input', {
    attrs: {
      "type": "hidden",
      "name": "ordr_idxx"
    },
    domProps: {
      "value": _vm.orderNo
    }
  }), _c('input', {
    attrs: {
      "type": "hidden",
      "name": "pay_method",
      "value": "110000000000"
    }
  }), _c('input', {
    attrs: {
      "type": "hidden",
      "name": "good_name"
    },
    domProps: {
      "value": _vm.orderName
    }
  }), _c('input', {
    attrs: {
      "type": "hidden",
      "name": "good_mny",
      "maxlength": "9"
    },
    domProps: {
      "value": _vm.paymentAmount
    }
  }), _c('input', {
    attrs: {
      "type": "hidden",
      "name": "buyr_name"
    },
    domProps: {
      "value": _vm.buyerName
    }
  }), _c('input', {
    attrs: {
      "type": "hidden",
      "name": "buyr_mail",
      "maxlength": "30"
    },
    domProps: {
      "value": _vm.buyerEmail
    }
  }), _c('input', {
    attrs: {
      "type": "hidden",
      "name": "buyr_tel1"
    },
    domProps: {
      "value": _vm.buyerPhone
    }
  }), _c('input', {
    attrs: {
      "type": "hidden",
      "name": "buyr_tel2"
    }
  }), _c('input', {
    attrs: {
      "type": "hidden",
      "name": "quotaopt",
      "value": "12"
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "hidden",
      "name": "rcvr_name",
      "size": "20"
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "hidden",
      "name": "rcvr_tel1",
      "size": "20"
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "hidden",
      "name": "rcvr_tel2",
      "size": "20"
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "hidden",
      "name": "rcvr_mail",
      "size": "40"
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "hidden",
      "name": "rcvr_zipx",
      "size": "6"
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "hidden",
      "name": "rcvr_add1",
      "size": "50"
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "hidden",
      "name": "rcvr_add2",
      "size": "50"
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "hidden",
      "name": "req_tx",
      "value": "pay"
    }
  }), _c('input', {
    attrs: {
      "type": "hidden",
      "name": "site_cd"
    },
    domProps: {
      "value": _vm.isDeduction ? _vm.siteCodeDeduction : _vm.siteCode
    }
  }), _c('input', {
    attrs: {
      "type": "hidden",
      "name": "site_name"
    },
    domProps: {
      "value": _vm.siteName
    }
  }), _c('input', {
    attrs: {
      "type": "hidden",
      "name": "site_key"
    },
    domProps: {
      "value": _vm.isDeduction ? _vm.siteKeyDeduction : _vm.siteKey
    }
  }), _c('input', {
    attrs: {
      "type": "hidden",
      "name": "module_type",
      "value": "01"
    }
  }), _c('input', {
    attrs: {
      "type": "hidden",
      "name": "currency",
      "value": "WON"
    }
  }), _c('input', {
    attrs: {
      "type": "hidden",
      "name": "escw_used",
      "value": "Y"
    }
  }), _c('input', {
    attrs: {
      "type": "hidden",
      "name": "pay_mod",
      "value": "O"
    }
  }), _c('input', {
    attrs: {
      "type": "hidden",
      "name": "deli_term",
      "value": "03"
    }
  }), _c('input', {
    attrs: {
      "type": "hidden",
      "name": "bask_cntx",
      "value": "1"
    }
  }), _c('input', {
    attrs: {
      "type": "hidden",
      "name": "good_info",
      "value": ""
    }
  }), _c('input', {
    attrs: {
      "type": "hidden",
      "name": "res_cd"
    }
  }), _c('input', {
    attrs: {
      "type": "hidden",
      "name": "res_msg",
      "value": ""
    }
  }), _c('input', {
    attrs: {
      "type": "hidden",
      "name": "tno",
      "value": ""
    }
  }), _c('input', {
    attrs: {
      "type": "hidden",
      "name": "trace_no",
      "value": ""
    }
  }), _c('input', {
    attrs: {
      "type": "hidden",
      "name": "enc_info"
    }
  }), _c('input', {
    attrs: {
      "type": "hidden",
      "name": "enc_data"
    }
  }), _c('input', {
    attrs: {
      "type": "hidden",
      "name": "ret_pay_method",
      "value": ""
    }
  }), _c('input', {
    attrs: {
      "type": "hidden",
      "name": "tran_cd"
    }
  }), _c('input', {
    attrs: {
      "type": "hidden",
      "name": "bank_name",
      "value": ""
    }
  }), _c('input', {
    attrs: {
      "type": "hidden",
      "name": "bank_issu",
      "value": ""
    }
  }), _c('input', {
    attrs: {
      "type": "hidden",
      "name": "use_pay_method"
    }
  }), _c('input', {
    attrs: {
      "type": "hidden",
      "name": "cash_tsdtime",
      "value": ""
    }
  }), _c('input', {
    attrs: {
      "type": "hidden",
      "name": "cash_yn"
    }
  }), _c('input', {
    attrs: {
      "type": "hidden",
      "name": "cash_authno",
      "value": ""
    }
  }), _c('input', {
    attrs: {
      "type": "hidden",
      "name": "cash_tr_code"
    }
  }), _c('input', {
    attrs: {
      "type": "hidden",
      "name": "cash_id_info",
      "value": ""
    }
  })]) : _c('form', {
    ref: "mobileForm",
    attrs: {
      "name": "order_info",
      "action": _vm.payUrl,
      "method": "post",
      "accept-charset": "euc-kr"
    }
  }, [_c('input', {
    attrs: {
      "type": "hidden",
      "name": "ordr_idxx"
    },
    domProps: {
      "value": _vm.orderNo
    }
  }), _c('input', {
    attrs: {
      "type": "hidden",
      "name": "good_name",
      "size": "30"
    },
    domProps: {
      "value": _vm.orderNo
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "hidden",
      "name": "good_mny",
      "size": "10"
    },
    domProps: {
      "value": _vm.paymentAmount
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "hidden",
      "name": "buyr_name",
      "size": "20"
    },
    domProps: {
      "value": _vm.buyerName
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "hidden",
      "name": "buyr_mail",
      "size": "25"
    },
    domProps: {
      "value": _vm.buyerEmail
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "hidden",
      "name": "buyr_tel1",
      "size": "20"
    },
    domProps: {
      "value": _vm.buyerPhone
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "hidden",
      "name": "buyr_tel2",
      "value": "",
      "size": "20"
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "hidden",
      "name": "payment",
      "value": "",
      "size": "20"
    }
  }), _c('input', {
    attrs: {
      "type": "hidden",
      "name": "course",
      "value": "",
      "size": "20"
    }
  }), _c('input', {
    attrs: {
      "type": "hidden",
      "name": "req_tx",
      "value": "pay"
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "hidden",
      "name": "shop_name"
    },
    domProps: {
      "value": _vm.siteName
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "hidden",
      "name": "site_cd"
    },
    domProps: {
      "value": _vm.isDeduction ? _vm.siteCodeDeduction : _vm.siteCode
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "hidden",
      "name": "currency",
      "value": "410"
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "hidden",
      "name": "eng_flag",
      "value": "N"
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "hidden",
      "name": "approval_key",
      "id": "approval"
    },
    domProps: {
      "value": _vm.approvalKey
    }
  }), _c('input', {
    attrs: {
      "type": "hidden",
      "name": "escw_used",
      "value": "N"
    }
  }), _c('input', {
    attrs: {
      "type": "hidden",
      "name": "pay_method",
      "value": "CARD"
    }
  }), _c('input', {
    attrs: {
      "type": "hidden",
      "name": "van_code",
      "value": ""
    }
  }), _c('input', {
    attrs: {
      "type": "hidden",
      "name": "quotaopt",
      "value": "12"
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "hidden",
      "name": "ipgm_date"
    },
    domProps: {
      "value": _vm.ipgmDate
    }
  }), _c('input', {
    attrs: {
      "type": "hidden",
      "name": "shop_user_id",
      "value": ""
    }
  }), _c('input', {
    attrs: {
      "type": "hidden",
      "name": "pt_memcorp_cd",
      "value": ""
    }
  }), _c('input', {
    attrs: {
      "type": "hidden",
      "name": "disp_tax_yn",
      "value": "Y"
    }
  }), _c('input', {
    attrs: {
      "type": "hidden",
      "name": "Ret_URL"
    },
    domProps: {
      "value": _vm.returnUrl
    }
  }), _c('input', {
    attrs: {
      "type": "hidden",
      "name": "tablet_size",
      "value": "1.0"
    }
  }), _vm._v("> "), _c('input', {
    attrs: {
      "type": "hidden",
      "name": "AppUrl",
      "value": "daehanbooks://"
    }
  }), _c('input', {
    attrs: {
      "type": "hidden",
      "name": "param_opt_1"
    }
  }), _c('input', {
    attrs: {
      "type": "hidden",
      "name": "param_opt_2"
    }
  }), _c('input', {
    attrs: {
      "type": "hidden",
      "name": "param_opt_3"
    }
  })])]);
}
var staticRenderFns = []

export { render, staticRenderFns }